import { EnergyDisplayMode, EnergyUseChart } from 'components/EnergyUseChart';
import { MainLayoutContext } from 'layouts/MainLayout';
import { useContext, useEffect } from 'react';
import { selectEnergyUse } from 'services/ThingsService';
import { useAppSelector } from 'store';
import {
  alignItems,
  display,
  flexDirection,
  fontSize,
  justifyContent,
  margin,
  overflow,
  padding,
  twCls,
} from 'style';

export const Energy = (): JSX.Element => {
  const { showNavigationButtons, showUserProfile } = useContext(MainLayoutContext);
  const energyUse = useAppSelector((state) => selectEnergyUse(state));

  useEffect(() => {
    showNavigationButtons(true);
    showUserProfile(true);
  }, [showNavigationButtons, showUserProfile]);

  return (
    <div className={twCls(margin('mt-6'), display('flex'), flexDirection('flex-col'))}>
      <h2 className={twCls(display('flex'), justifyContent('justify-center'))}>Energy Use</h2>
      {energyUse && (
        <div
          className={twCls(display('flex'), flexDirection('flex-col'), overflow('overflow-auto'))}
        >
          <div className={twCls(display('flex'), justifyContent('justify-center'), margin('mt-6'))}>
            <span className={twCls(fontSize('text-4xl'))}>
              {(energyUse.currentUse / 1000).toFixed(2)}
            </span>
            <span className={twCls(display('flex'), alignItems('items-end'), padding('pb-0.5'))}>
              kWh
            </span>
          </div>
          <div
            className={twCls(
              display('flex'),
              justifyContent('justify-center'),
              fontSize('text-sm'),
            )}
          >
            Electricity used so far today
          </div>
          <div className={twCls(margin('mt-6'))}>
            <EnergyUseChart
              title="Weekly Use"
              type={EnergyDisplayMode.Weekly}
              data={energyUse.weeklyUse}
              average={energyUse.averageWeekly}
            />
          </div>
          <div className={twCls(margin('mt-6'))}>
            <EnergyUseChart
              title="Monthly Use"
              type={EnergyDisplayMode.Monthly}
              data={energyUse.monthlyUse}
              average={energyUse.averageMonthly}
            />
          </div>
        </div>
      )}
    </div>
  );
};
